import React, { useEffect, useState, useRef, useCallback } from "react";
import TopBar from "../TopBar/TopBar";
import BottomBar from "../BottomBar/BottomBar";
import ChatQueue from "../ChatQueue/ChatQueue";
import SourceDialog from "../../../Shared/Components/SourceDialog/SourceDialog";
import PdfViewer from "../PdfViewer/PdfViewer";
import {
  isIframeDeployment,
  getMessages,
  getProcessedCustomPayload,
  getUserApproach,
  getUserCadre,
  getUserKb,
  getUserMessageBlock,
  getUserToken,
  saveSelectedDocument,
  stopPlayingAudio,
  pausePlayingAudio,
  setNewSessionFlag,
  getNewSessionFlag,
} from "../../../Actions/Utils";
import { useNavigate } from "react-router-dom";
import { modelInresponsive, sendChatFeedback, starBotAnswer, submit } from "../../../Actions/ChatActions";
import Loader from "../../../Shared/Components/Loader/Loader";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";
import { ToastSeverityMap } from "../../../NewConstants/ToastConstants";
import HelpFeedbackDialog from "../../../Shared/Components/HelpFeedbackDialog/HelpFeedbackDialog";
import { sendUserFeedback } from "../../../Actions/UserActions";
import { modelNotRespondingConstant } from "../../../NewConstants/ErrorConstants";
import { trackEvent } from "../../../Actions/Utils";
import { dummyBlock } from "../../../NewConstants/ChatConstants";
import Tooltip from "../Tooltip/Tooltip";
import TooltipChecklist from "../TooltipChecklist/TooltipChecklist";
import PwaInstallBanner from "../../../Shared/Components/PwaInstallBanner/PwaInstallBanner";

// Helper function to compute last question chips index
function getLastQuestionChipsIdx(chatArr) {
  for (let i = chatArr.length - 1; i >= 0; i--) {
    if (
      chatArr[i]?.bot?.options &&
      chatArr[i].bot.options.length > 0 &&
      !chatArr[i]?.bot?.welcome
    ) {
      return i;
    }
  }
  return undefined;
}

// Helper function to compute last star index
function getLastStarIdx(chatArr) {
  for (let i = chatArr.length - 1; i >= 0; i--) {
    if (
      !chatArr[i]?.bot?.error?.code &&
      Object.keys(chatArr[i]?.bot?.text || {}).length > 0 &&
      !chatArr[i]?.bot?.welcome
    ) {
      return i;
    }
  }
  return undefined;
}

// Helper function to compute last source index
function getLastSourceIdx(chatArr) {
  for (let i = chatArr.length - 1; i >= 0; i--) {
    if (chatArr[i]?.bot?.sources?.length > 0) {
      return i;
    }
  }
  return undefined;
}

const ChatBody = ({
  selectedLanguage,
  textSize,
  setSelectedLanguage = () => {},
  decreaseTextSize = () => {},
  increaseTextSize = () => {},
  stepIndex,
  setStepIndex,
  startTour,
  setStartTour,
}) => {
  let navigate = useNavigate();
  const [inputText, setInputText] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [chatArr, setChatArr] = useState([]);
  const userProfileData = JSON.parse(localStorage.getItem("userProfileData"));
  const [isLoading, setIsLoading] = useState(false);
  const [sourceDialogFlag, setSourceDialogFlag] = useState(false);
  const [selectedSourceData, setSelectedSourceData] = useState(null);
  const [sourceLanguage, setSourceLanguage] = useState(null);
  const [currentBlock, setCurrentBlock] = useState(null);
  const chatBodyRef = useRef(null);
  const [oldestOffset, setOldestOffset] = useState(null);
  const [messageLoader, setMessageLoader] = useState(false);
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const audioRef = useRef(null);
  const [speakerEnabled, setSpeakerEnabled] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(localStorage.getItem('selectedDocument') || null);
  const [currentOffset, setCurentOffset] = useState(null);
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const [toastMessageSeverity, setToastMessageSeverity] = useState("");
  const [scrollToBottonFlag, setScrollToBottomFlag] = useState(false);
  const [audioArr, setAudioArr] = useState([]);
  const [showSpeakerActive, setShowSpeakerActive] = useState(true);
  // const [startTour, setStartTour] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [pdfViewerOpen, setPdfViewerOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfPage, setPdfPage] = useState(null);
  const [speakerOpen, setSpeakerOpen] = useState(false);
  const [optionClicked, setOptionClicked] = useState(false);
  const [chipsClicked, setChipsClicked] = useState(false);
  const [optionSelected, setOptionSelected] = useState(false);
  const [defaultChipsClicked, setDefaultChipsClicked] = useState(false);
  const [showQuestionChips, setShowQuestionChips] = useState(false);
  const [showTooltipChecklist, setShowTooltipChecklist] = useState(false);
  const [questionChipsClicked, setQuestionChipsClicked] = useState(false);
  const [defaultQuestionChipsClicked, setDefaultQuestionChipsClicked] = useState(false);
  const [showTooltipStar, setShowTooltipStar] = useState(false);
  const [defaultShowTooltipStar, setDefaultShowTooltipStar] = useState(false);
  const [sendClicked, setSendClicked] = useState(false);
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [pendingNewChat, setPendingNewChat] = useState(() => getNewSessionFlag());
  const [showNewChatPrompt, setShowNewChatPrompt] = useState(pendingNewChat);

  useEffect(() => {
    if (chatArr.length === 0 || pendingNewChat) return;
    setCurrentSessionId((prev) => {
      if (prev !== null) return prev;
      const sid = chatArr[chatArr.length - 1]?.session_id;
      return sid || null;
    });
  }, [chatArr, pendingNewChat]);

  function sendClickedFunction() {
    setSendClicked(true);
  }

  // Add refs for chipsClicked and defaultChipsClicked
  const chipsClickedRef = useRef(chipsClicked);
  const defaultChipsClickedRef = useRef(defaultChipsClicked);
  const questionChipsClickedRef = useRef(questionChipsClicked);
  const defaultShowTooltipStarRef = useRef(defaultShowTooltipStar);

  // Centralized function to trigger the tooltip star
  const triggerTooltipStar = useCallback(() => {
    setShowTooltipStar(true);
    // Add any additional logic here if needed (e.g., logging, analytics)
  }, []);
  // Sync refs with state
  useEffect(() => {
    chipsClickedRef.current = chipsClicked;
  }, [chipsClicked]);

  useEffect(() => {
    defaultChipsClickedRef.current = defaultChipsClicked;
  }, [defaultChipsClicked]);

  useEffect(() => {
    questionChipsClickedRef.current = questionChipsClicked;
  }, [questionChipsClicked]);

  useEffect(() => {
    defaultShowTooltipStarRef.current = defaultShowTooltipStar;
  }, [defaultShowTooltipStar]);
  useEffect(() => {
    if (getUserToken()) {
      populateChat();
    } else {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }

    const handleVisibilityChange = () => {
      if (document.hidden) {
        pausePlayingAudio(audioRef);
        setSpeakerEnabled(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, document.title, window.location.href);
    };

    window.addEventListener("popstate", handlePopState);
    setScrollToBottomFlag(true);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      setSpeakerEnabled(false);
      stopPlayingAudio(audioRef, "ChatBody:help/menu/input/sources");
    }
  }, [isHelpOpen, inputText, isMenuOpen, sourceDialogFlag]);

  const handleScroll = () => {
    if (oldestOffset > 0 && chatBodyRef.current.scrollTop === 0) {
      populateChat(oldestOffset);
    }
  };

  useEffect(() => {
    const chatBodyCurrent = chatBodyRef.current;
    if (chatBodyCurrent) {
      chatBodyCurrent.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (chatBodyCurrent) {
        chatBodyCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [oldestOffset]);

  async function populateChat(offset = null) {
    setMessageLoader(true);
    try {
      const res = await getMessages(offset);
      if (res?.status === 200) {
        setChatArr((prevChat) => {
          let arr = [];
          const response = res["data"]["Response"];
          response.forEach((message, idx) => {
            if (idx === response.length - 1) {
              setOldestOffset(message.offset - 1);
            }
            arr.unshift(message);
          });
          const merged = [...arr, ...prevChat];
          const last = merged[merged.length - 1];
          if (last?.offset > currentOffset) {
            setCurentOffset(last.offset);
          }
          return merged;
        });
      }
      if(res?.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      }
      if(res?.status === 500) {
        setToastErrorMessage(res?.data?.detail);
        setToastMessageSeverity(ToastSeverityMap.error);
        setShowToastMessage(true);
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setMessageLoader(false);
    }
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleHelp = () => {
    setIsHelpOpen(!isHelpOpen);
  };

  const openSourceDialog = (sourceData, language) => {
    setSourceDialogFlag(true);
    setSelectedSourceData(sourceData);
    setSourceLanguage(language);
    trackEvent("Source", "Click", "Open Source Block");
  };

  const closeSourceDialog = () => {
    setSourceDialogFlag(false);
    setSelectedSourceData(null);
  };

  const openPdfViewer = (source) => {
    const url = source?.en_link;
    setPdfUrl(url);
    setPdfViewerOpen(true);
    setPdfPage(null); // Page will be extracted from URL in PdfViewer
  };
  const closePdfViewer = () => {
    setPdfViewerOpen(false);
    setPdfUrl("");
    setPdfPage(null);
  };

  const appendLoaderBlock = useCallback((arr) => {
    arr[arr.length - 1]["bot"] = dummyBlock["bot"];
    arr[arr.length - 1]["dummy"] = dummyBlock["dummy"];
    setCurrentBlock(arr[arr.length - 1]);
    return arr;
  }, []);

  const appendUserChatBlock = useCallback(
    (arr, input, image = null, blockSessionId = null) => {
      let defaultFlag = arr[arr.length - 1]?.bot?.welcome || false;
      let block = getUserMessageBlock(
        input?.selectedLanguage || input,
        defaultFlag,
        image,
        selectedLanguage,
        blockSessionId
      );
      arr.push(block);
      setCurrentBlock(block);
      const newArr = appendLoaderBlock(arr);
      setChatArr(newArr);
      setIsLoading(true);
      return newArr;
    },
    [appendLoaderBlock, selectedLanguage]
  );

  const updateLastPromptSelectedChip = useCallback(
    (index) => {
      let arr = [...chatArr];
      const lastIndex = arr.length - 1;
      if (arr[lastIndex]?.bot) {
        arr[lastIndex] = {
          ...arr[lastIndex],
          bot: {
            ...arr[lastIndex].bot,
            selectedChipIndex: index,
          },
        };
      }
      return arr;
    },
    [chatArr]
  );

  const updateSelectedDocument = useCallback(
    (input, chatObj) => {
      if (getUserKb() === "GHS" && chatObj["bot"]["welcome"]) {
        setSelectedDocument(input);
        saveSelectedDocument(input);
      }
    },
    [setSelectedDocument]
  );

  const getModelAnswer = useCallback(async (arr, offset) => {
    const maxTries = 60; // Max polling attempts
    let tries = 0;
    let newOffset = offset;
    let res = null;
  
    // Initial delay of 6 seconds before starting long polling
    await new Promise((resolve) => setTimeout(resolve, 6000));
  
    // Long polling logic with incremental delay
    while (tries < maxTries) {
      // Fetch messages with the current offset
      res = await getMessages(newOffset, "forward");
      if (res?.status === 200) {
        const responseOffset = res["data"].Response[0]?.offset;
        const modelResponseFlag = res["data"].Response[0]?.bot?.model_response_time;
        if (responseOffset && responseOffset > newOffset && modelResponseFlag) {
          // If a new offset is received, update the array and break the loop
          const preservedSessionId = arr[arr.length - 1]?.session_id;
          const firstResp = res["data"].Response[0];
          arr[arr.length - 1] = {
            ...firstResp,
            session_id: firstResp.session_id || preservedSessionId,
          };
          delete arr[arr.length - 1]["dummy"];
          res["data"].Response.forEach((chatObj, index) => {
            if (index > 0) {
              const chainSid = arr[arr.length - 1]?.session_id;
              arr.push({
                ...chatObj,
                session_id: chatObj.session_id || chainSid,
              });
            }
          });
          setChatArr(arr);
          if (chipsClickedRef.current || defaultChipsClickedRef.current){
            setShowQuestionChips(true);
          }
          if (defaultShowTooltipStarRef.current || questionChipsClickedRef.current){
            triggerTooltipStar();
          }
          setCurrentBlock(arr[arr.length - 1]);
          setCurentOffset(arr[arr.length - 1]["offset"]);
          const resolvedSid = arr[arr.length - 1]?.session_id;
          if (resolvedSid) {
            setCurrentSessionId(resolvedSid);
          }
          break; // Exit polling when new offset is received
        }
        if (res?.status === 401) {
          localStorage.clear();
          sessionStorage.clear();
          navigate("/login");
        }
        if (res?.status === 500) {
          // Handle error
          arr[arr.length - 1]["bot"]["error"] = { code: 500 };
          arr[arr.length - 1]["bot"]["datetime"] = new Date();
          delete arr[arr.length - 1]["dummy"];
          setToastErrorMessage(res?.data?.detail);
          setToastMessageSeverity(ToastSeverityMap.error);
          setShowToastMessage(true);
          break; // Exit the polling loop on error
        }
      }
  
      // Increment tries and wait with an increasing delay before retrying
      tries++;
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Incremental delay
    }
  
    // Check if polling exhausted without receiving a new offset
    if (tries === maxTries) {
      // Set an error indicating no new offset was received
      arr[arr.length - 1]["bot"]["error"] = { code: 501, message: "Model is not responding." };
      arr[arr.length - 1]["bot"]["text"] = modelNotRespondingConstant;
      arr[arr.length - 1]["bot"]["datetime"] = new Date();
      delete arr[arr.length - 1]["dummy"];
      const res = await modelInresponsive(getUserToken(), getUserCadre(), getUserKb(), getUserApproach());
      console.log(res);
    }
  
    // Set loading state to false after polling finishes
    setIsLoading(false);
  }, [navigate, triggerTooltipStar]);
  

  const submitResponse = useCallback(
    async (index, input, customQueryFlag, image = null, newSession = false) => {
      let normalizedInput = input;
      if (typeof input === "string") {
        normalizedInput = input.trim();
        if (!normalizedInput) {
          setToastErrorMessage("Message cannot be empty.");
          setToastMessageSeverity(ToastSeverityMap.error);
          setShowToastMessage(true);
          return;
        }
      }
      const pendingNewSessionFromBtn = getNewSessionFlag();
      const effectiveNewSession = newSession || pendingNewSessionFromBtn;

      setPendingNewChat(false);
      setShowNewChatPrompt(false);

      const payloadSessionId =
        !effectiveNewSession && currentSessionId ? currentSessionId : null;

      let blockSessionId = null;
      if (effectiveNewSession) {
        blockSessionId =
          typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : `pending-${Date.now()}`;
        setCurrentSessionId(blockSessionId);
      } else if (currentSessionId) {
        blockSessionId = currentSessionId;
      }

      let arr = updateLastPromptSelectedChip(index);
      // For GHS usecase, update selected document
      updateSelectedDocument(normalizedInput, arr[arr.length - 1]);
      arr = appendUserChatBlock(arr, normalizedInput, image, blockSessionId);
      const res = await submit(
        getUserToken(),
        getProcessedCustomPayload(
          normalizedInput,
          audioArr,
          selectedLanguage,
          customQueryFlag,
          image,
          {
            newSession: effectiveNewSession,
            sessionId: payloadSessionId,
          }
        )
      );
      setAudioArr([]);
      if (res?.status === 200) {
        if (pendingNewSessionFromBtn) {
          setNewSessionFlag(false);
        }
        getModelAnswer(arr, currentOffset);
      }
      if (res?.status === 401) {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/login");
      }
      if (res?.status === 500) {
        setToastErrorMessage(res?.data?.detail);
        setToastMessageSeverity(ToastSeverityMap.error);
        setShowToastMessage(true);
      }
    },
    [
      audioArr,
      selectedLanguage,
      currentOffset,
      currentSessionId,
      navigate,
      updateLastPromptSelectedChip,
      updateSelectedDocument,
      appendUserChatBlock,
      getModelAnswer,
    ]
  );

  const handleNewChatClick = useCallback(() => {
    setCurrentSessionId(null);
    setPendingNewChat(true);
    setShowNewChatPrompt(true);
    setNewSessionFlag(true);
  }, []);

  async function sendFeedback(feedback) {
    let temp = [...chatArr];
    const res = await sendChatFeedback(getUserToken(), temp[temp.length - 1]._id, feedback.value);
    if (res?.status === 200) {
      temp[temp.length - 1].bot.feedback_type = feedback.value;
      setChatArr(temp);
    }
    if(res?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
    if(res?.status === 500) {
      setToastErrorMessage(res?.data?.detail);
      setToastMessageSeverity(ToastSeverityMap.error);
      setShowToastMessage(true);
    }
  }

  async function markFavourite(idx, id, starFlag) {
    let arr = [...chatArr];
    const res = await starBotAnswer(getUserToken(), id, starFlag);
    if (res?.status === 200) {
      arr[idx]["bot"]["starred"] = starFlag;
      setChatArr(arr);
    }
    if(res?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
    if(res?.status === 500) {
      setToastErrorMessage(res?.data?.detail);
      setToastMessageSeverity(ToastSeverityMap.error);
      setShowToastMessage(true);
    }
  }

  async function submitFeedback(feedback) {
    trackEvent("Feedback/Support", "Click", "send their feedback/concern");
    const res = await sendUserFeedback(getUserToken(), feedback);
    if (res?.status === 200) {
      setIsHelpOpen(false);
      setToastErrorMessage(res?.data?.detail);
      setToastMessageSeverity(ToastSeverityMap.success);
      setShowToastMessage(true);
    }
    if(res?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
    if(res?.status === 500) {
      setIsHelpOpen(false);
      setToastErrorMessage(res?.data?.detail);
      setToastMessageSeverity(ToastSeverityMap.error);
      setShowToastMessage(true);
    }
  }
  

  useEffect(() => {
    setLoaded(true);
  }, []);

  const handleStartTour = () => {
    setStartTour(true);
  };

  const handleTourEnd = () => {
    setStartTour(false);
  };

  // Handler for question chips clicked
  const handleQuestionChipClicked = () => {
    setQuestionChipsClicked(true);
  };

  useEffect(() => {
    if (defaultQuestionChipsClicked) {
      // Find the last question chips index
      const lastIdx = getLastQuestionChipsIdx(chatArr);
      if (
        lastIdx !== undefined &&
        chatArr[lastIdx]?.bot?.options &&
        chatArr[lastIdx]?.bot?.options[0]
      ) {
        const options = chatArr[lastIdx].bot.options;
        const selectedLanguageOption =
          options[0][selectedLanguage] || options[0];
        submitResponse(0, selectedLanguageOption, false, null);
      }
      setDefaultQuestionChipsClicked(false);
      setDefaultShowTooltipStar(true);
    }
  }, [
    defaultQuestionChipsClicked,
    selectedLanguage,
    chatArr,
    submitResponse,
    setDefaultQuestionChipsClicked,
    setDefaultShowTooltipStar,
  ]);

  if (!loaded) {
    return null;
  }
  
  return (
    <>
      <div>
        <div
          className="flex flex-col h-screen-safe bg-cover bg-no-repeat"
          style={{
            backgroundImage: `url("/Assets/Images/bgWallpaper.svg")`,
          }}
        >
          <PwaInstallBanner selectedLanguage={selectedLanguage} />
          <TopBar
            userData={userProfileData}
            isMenuOpen={isMenuOpen}
            toggleMenu={toggleMenu}
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={setSelectedLanguage}
            textSize={textSize}
            decreaseTextSize={decreaseTextSize}
            increaseTextSize={increaseTextSize}
            toggleHelp={toggleHelp}
            setStartTour={setStartTour}
            showTooltipChecklist={showTooltipChecklist}
            setShowTooltipChecklist={setShowTooltipChecklist}
          />
          <div
            className="overflow-hidden overflow-y-scroll scroll-smooth min-h-0 flex-grow"
            ref={chatBodyRef}
          >
            {messageLoader && (
              <div className="absolute w-[100vw] z-[2] flex justify-center my-4">
                <Loader />
              </div>
            )}
            <div className="flex items-center justify-center pt-2"></div>
            <div>
              {chatArr.length > 0 && (
                <ChatQueue
                  selectedLanguage={selectedLanguage}
                  chatArr={chatArr}
                  isLoading={isLoading}
                  openSourceDialog={openSourceDialog}
                  populateChat={populateChat}
                  currentBlock={currentBlock}
                  textSize={textSize}
                  sendFeedback={sendFeedback}
                  submitResponse={submitResponse}
                  audioRef={audioRef}
                  speakerEnabled={speakerEnabled}
                  setSpeakerEnabled={setSpeakerEnabled}
                  markFavourite={markFavourite}
                  setToastErrorMessage={setToastErrorMessage}
                  setShowToastMessage={setShowToastMessage}
                  scrollToBottonFlag={scrollToBottonFlag}
                  start={startTour}
                  setStartTour={setStartTour}
                  onTourEnd={handleTourEnd}
                  speakerOpen={speakerOpen}
                  setSpeakerOpen={setSpeakerOpen}
                  defaultQuestionChipsClicked={defaultQuestionChipsClicked}
                  setDefaultQuestionChipsClicked={setDefaultQuestionChipsClicked}
                  questionChipClicked={handleQuestionChipClicked}
                  currentSessionId={currentSessionId}
                  showNewChatPrompt={showNewChatPrompt}
                  pendingNewChat={pendingNewChat}
                  onNewChatClick={handleNewChatClick}
                />
              )}
            </div>
          </div>
          <BottomBar
            audioRef={audioRef}
            input={inputText}
            setInput={setInputText}
            setAudioArr={setAudioArr}
            audioArr={audioArr}
            selectedLanguage={selectedLanguage}
            send={submitResponse}
            textSize={textSize}
            isLoading={isLoading}
            stopPlayingAudio={stopPlayingAudio}
            setSpeakerEnabled={setSpeakerEnabled}
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
            setToastErrorMessage={setToastErrorMessage}
            setShowToastMessage={setShowToastMessage}
            setToastMessageSeverity={setToastMessageSeverity}
            optionClicked={optionClicked}
            setOptionClicked={setOptionClicked}
            chipsClicked={chipsClicked}
            setChipsClicked={setChipsClicked}
            optionSelected={optionSelected}
            setOptionSelected={setOptionSelected}
            defaultChipsClicked={defaultChipsClicked}
            setDefaultChipsClicked={setDefaultChipsClicked}
            sendClickedFunction={sendClickedFunction}
          />
        </div>
        {showTooltipChecklist && (
          <TooltipChecklist
            selectedLanguage={selectedLanguage}
            setShowTooltipChecklist={setShowTooltipChecklist}
            startTour={startTour}
            setStartTour={setStartTour}
          />
        )}
        {startTour && (
          <Tooltip
            start={startTour}
            setStartTour={setStartTour}
            onTourEnd={handleTourEnd}
            selectedLanguage={selectedLanguage}
            audioRef={audioRef}
            speakerEnabled={speakerEnabled}
            setSpeakerEnabled={setSpeakerEnabled}
            showSpeakerActive={showSpeakerActive}
            setShowSpeakerActive={setShowSpeakerActive}
            lastWelcomeIdx={(() => {
              for (let i = chatArr.length - 1; i >= 0; i--) {
                if (chatArr[i]?.bot?.welcome) return i;
              }
              return undefined;
            })()}
            lastSpeakerIdx={(() => {
              for (let i = chatArr.length - 1; i >= 0; i--) {
                if (chatArr[i]?.bot?.welcome) return i;
              }
              return undefined;
            })()}
            lastQuestionChipsIdx={getLastQuestionChipsIdx(chatArr)}
            lastStarIdx={getLastStarIdx(chatArr)}
            speakerOpen={speakerOpen}
            setSpeakerOpen={setSpeakerOpen}
            setInput={setInputText}
            optionClicked={optionClicked}
            setOptionClicked={setOptionClicked}
            chipsClicked={chipsClicked}
            setChipsClicked={setChipsClicked}
            optionSelected={optionSelected}
            setOptionSelected={setOptionSelected}
            defaultChipsClicked={defaultChipsClicked}
            setDefaultChipsClicked={setDefaultChipsClicked}
            chatArr={chatArr}
            showQuestionChips={showQuestionChips}
            setShowQuestionChips={setShowQuestionChips}
            setDefaultQuestionChipsClicked={setDefaultQuestionChipsClicked}
            questionChipsClicked={questionChipsClicked}
            setQuestionChipsClicked={setQuestionChipsClicked}
            showTooltipStar={showTooltipStar}
            setShowTooltipStar={setShowTooltipStar}
            lastSourceIdx={getLastSourceIdx(chatArr)}
            setDefaultShowTooltipStar={setDefaultShowTooltipStar}
            setToastErrorMessage={setToastErrorMessage}
            setShowToastMessage={setShowToastMessage}
            stepIndex={stepIndex}
            setStepIndex={setStepIndex}
            sendClicked={sendClicked}
            setSendClicked={setSendClicked}
          />
        )}
        {sourceDialogFlag && (
          <div className="absolute top-0 left-0 h-screen-safe w-screen z-20">
            <SourceDialog
              selectedLanguage={selectedLanguage}
              sourceLanguage={sourceLanguage}
              sourceData={selectedSourceData}
              closeDialog={closeSourceDialog}
              openPdfViewer={openPdfViewer}
            />
          </div>
        )}
        {pdfViewerOpen && (
          <PdfViewer
            selectedLanguage={selectedLanguage}
            pdfUrl={pdfUrl}
            open={pdfViewerOpen}
            onClose={closePdfViewer}
            page={pdfPage}
          />
        )}
      </div>
      {isHelpOpen && (
        <div className="absolute top-0 left-0 h-screen-safe w-screen z-20">
          <HelpFeedbackDialog textSize={textSize} selectedLangauge={selectedLanguage} toggleHelp={toggleHelp} submitFeedback={submitFeedback} />
        </div>
      )}
      {
        showToastMessage && <ToastMessage message={toastErrorMessage} severity={toastMessageSeverity} direction={"bottom"} close={setShowToastMessage}/>
      }
    </>
  );
};

export default ChatBody;
